
function checkNull(value){

  if(value !== null && value !== undefined && value !== 'undefined' && JSON.stringify(value) !== '{}' && JSON.stringify(value) !== '[]'){

    return value;

  } else {

    return null;
  }
}


function mergeObjSpread(acc,value){

    return {...acc, ...value};

}

function isNumber(n) {

        return !isNaN(parseFloat(n)) && isFinite(n);
}


function findObj(arr,key,val){ 

    return R.find(R.propEq(key, val))(arr);
}


function returnItem(obj,string){

  return obj[string] ? obj[string] : '';
}



function clearDataAttr(arr){

	return R.map(function(n){

          n.data = R.map(function(j){

            return "";

          }, n.data);

          return n;

        }, arr);

}



function sessionValue(key, value){

    if(value){ 

        sessionStorage.setItem(key, value);

    } else { 

      if(sessionStorage[key]){

          return sessionStorage.getItem(key);

      } else {

          return null;
      }
    }
}

function localValue(key, value){

    if(value){ 

        localStorage[key] = value;

    } else { 

      if(localStorage[key]){

          return localStorage[key];

      } else {

          return null;
      }
    }
}


function getPrincipal(key, value){

    if(localStorage.principal){

        var p = JSON.parse(localStorage.principal);

         if(value){ 

            p[key] = value;

          } else { 

            if(p[key]){

              return p[key];

            } else {

              return null;
            }
          }

    } else {

        return null;

    }
}


function getSessionData(objName,key){

        if(sessionStorage[objName]){

      if(sessionStorage[objName][key]){

        return sessionStorage[objName][key];

            } else {

        return false;
      }

    } else {

      return false;
    }

  }


function fetchUser(userName) {

    var users = JSON.parse(sessionStorage.users)

    for (var user in users){
    if(users[user]['userName'] === userName){
      return users[user];
    }
  }

  return null;
}



function setCookie(keyStr){

  document.cookie = keyStr;
}


function getMasterProducerId(){

  var user = getPrincipal('userType');
  var pd = JSON.parse(sessionValue('producerDetail'));

  if (pd) {
      localStorage.setItem('producerDetail', JSON.stringify(pd));
  } else {
      pd = JSON.parse(localStorage.getItem('producerDetail'));
  }

  if(user){

     var f = {

      'Agent':function(p){

          return getPrincipal('masterProducerId');
      },

      'Employee':function(p){

        if(p){

          return (p.contractAccount !== undefined) ?  p.contractAccount.webProfileId : p.portalAccount.masterProducerId;

        } else {

          return false;
        }
      },

      'CompanyAdmin':function(p){

        return getPrincipal('masterProducerId');

      },

      'CompanyRep':function(p){

        return getPrincipal('masterProducerId');

              }

    }

    return f[user](pd);

  } else { 

    return false;

  }

 }


